export default __webpack_public_path__ + "static/media/dungeon-maze-demo.452ef3e8.gif";